import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Library, ArrowLeft } from "lucide-react";
import NavBar from "@/library/components/NavBar";
import Footer from "@/library/components/Footer";
import Breadcrumbs from "@/library/components/Breadcrumbs";
import { api } from "@/library/lib/api";

const Levels = () => {
  const [levels, setLevels] = useState([]);
  useEffect(() => { api.get("/levels").then((r) => setLevels(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="levels-page" className="min-h-screen flex flex-col bg-[#F5F7FA]">
      <NavBar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex-1 w-full">
        <Breadcrumbs items={[{ label: "الرئيسية", to: "/" }, { label: "المراحل الدراسية" }]} />
        <div className="mb-10">
          <h1 className="font-heading text-3xl md:text-4xl font-extrabold text-brand-dark">المراحل التعليمية</h1>
          <div className="gold-line mt-3"></div>
          <p className="text-slate-600 mt-4 max-w-2xl">اختر إحدى المراحل لاستعراض المجالات والمؤشرات المرتبطة بها.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {levels.map((l, i) => (
            <motion.div key={l.id} initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.08 }}>
              <Link to={`/library/levels/${l.id}`} data-testid={`level-card-${l.id}`} className="premium-card p-8 block group h-full">
                <div className="w-14 h-14 rounded-2xl bg-brand/8 text-brand flex items-center justify-center mb-5 group-hover:bg-gold/15 group-hover:text-gold-dark transition-colors">
                  <Library className="w-7 h-7" />
                </div>
                <h3 className="font-heading text-xl font-bold text-brand-dark mb-2">{l.name}</h3>
                <p className="text-sm text-slate-600 leading-relaxed mb-5">{l.description}</p>
                <div className="text-gold-dark font-bold text-sm flex items-center gap-2 group-hover:gap-3 transition-all">
                  <span>عرض المجالات</span> <ArrowLeft className="w-4 h-4" />
                </div>
              </Link>
            </motion.div>
          ))}
          {levels.length === 0 && <div className="col-span-3 text-center py-16 text-slate-500">لا توجد مراحل</div>}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Levels;
